import { createSelector } from 'reselect';
import { optimizeShippingCopyPLPSelector } from 'selectors/testTarget/offers/optimizeShippingCopyPLP/optimizeShippingCopyPLPSelector';

const activeSelector = createSelector(optimizeShippingCopyPLPSelector, optimizeShippingCopyPLP => !!optimizeShippingCopyPLP.active);

export { activeSelector };
